"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "The Ritz-Carlton",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_ritz_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_ritz_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_ritz_logo.png-wvc-sizes",
  alt: "The Ritz-Carlton Logo"
}, {
  id: 2,
  name: "Monaco Yacht Club",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_monaco_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_monaco_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_monaco_logo.png-wvc-sizes",
  alt: "Monaco Yacht Club Logo"
}, {
  id: 3,
  name: "Four Seasons",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_fourseasons_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_fourseasons_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_fourseasons_logo.png-wvc-sizes",
  alt: "Four Seasons Logo"
}, {
  id: 4,
  name: "Royal Yacht Squadron",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_royal_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_royal_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_royal_logo.png-wvc-sizes",
  alt: "Royal Yacht Squadron Logo"
}, {
  id: 5,
  name: "Aman Resorts",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_aman_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_aman_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_aman_logo.png-wvc-sizes",
  alt: "Aman Resorts Logo"
}, {
  id: 6,
  name: "St. Regis",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_stregis_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_stregis_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_stregis_logo.png-wvc-sizes",
  alt: "St. Regis Logo"
}];
export default function SignaturePartnerships() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="signature-partnerships" className="bg-background w-full">
      <div ref={ref} className={`relative w-full bg-gradient-to-b from-foreground to-chart-3 py-24 overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        {}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/40 to-transparent" />

        <div className="container mx-auto px-4 md:px-8">
          <h2 className="sr-only font-default">Signature Partnerships</h2>

          <Carousel opts={{
          align: "start",
          loop: true,
          duration: 80
        }} className="w-full max-w-6xl mx-auto">
            <CarouselContent className="-ml-4 md:-ml-8 items-center">
              {partners.map((partner, i) => <CarouselItem key={partner.id} data-index={i} className="pl-4 md:pl-8 basis-1/2 md:basis-1/3 lg:basis-1/4 flex flex-col items-center justify-center group">
                  <div className="h-20 w-full flex items-center justify-center mb-5">
                    <img src={partner.logo} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.alt} className="max-h-full max-w-[140px] object-contain brightness-0 invert opacity-50 transition-all duration-700 ease-in-out group-hover:opacity-90 group-hover:scale-105" loading="lazy" />
                  </div>
                  <p className="font-mono text-xs tracking-widest text-muted/50 uppercase text-center transition-colors duration-500 group-hover:text-secondary/80">
                    {partner.name}
                  </p>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden md:block">
              <CarouselPrevious className="border-secondary/20 text-secondary/60 hover:bg-secondary/10 hover:text-secondary -left-12 bg-transparent transition-colors duration-300" />
              <CarouselNext className="border-secondary/20 text-secondary/60 hover:bg-secondary/10 hover:text-secondary -right-12 bg-transparent transition-colors duration-300" />
            </div>
          </Carousel>
        </div>

        {}
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/40 to-transparent" />
      </div>
    </section>;
}